// audioService.js - Fixed implementation
import api from './api';

// Get audio recordings for an estimate
export const getAudioRecordings = async (estimateId) => {
  try {

    const response = await api.get(`/audio/estimate/${estimateId}/recordings`);

    return response.data;
  } catch (error) {
    console.error('Error getting audio recordings:', error);
    throw error;
  }
};

// Transcribe audio recording
export const transcribeAudio = async (recordingId) => {
  try {

    const response = await api.post(`/audio/${recordingId}/transcribe`);

    return response.data;
  } catch (error) {
    console.error(`Error transcribing audio ${recordingId}:`, error);
    throw error;
  }
};

// Process audio with AI
export const processAudioWithAI = async (recordingId) => {
  try {

    const response = await api.post(`/audio/${recordingId}/process-with-ai`);
    
    // Additional logging to debug door extraction

    if (response.data.doors) {

      // Log each door's details
      response.data.doors.forEach((door, index) => {
      });
    } else {
      console.warn(`No doors extracted from recording ${recordingId}`);
    }
    
    return response.data;
  } catch (error) {
    console.error(`Error processing audio ${recordingId} with AI:`, error);
    throw error;
  }
};

// Delete audio recording
export const deleteAudio = async (recordingId) => {
  try {

    const response = await api.delete(`/audio/${recordingId}/delete`);

    return response.data;
  } catch (error) {
    console.error(`Error deleting audio ${recordingId}:`, error);
    throw error;
  }
};

// Upload audio file (specifically for use in AudioRecorder.js)
export const uploadAudio = async (audioBlob, estimateId) => {
  if (!audioBlob || audioBlob.size === 0) {
    throw new Error('Audio file is empty or invalid');
  }

  try {


    // Create a proper file with name and type
    const audioFile = new File(
      [audioBlob], 
      'recording.wav',
      { type: audioBlob.type || 'audio/wav' }
    );
    
    const formData = new FormData();
    formData.append('audio', audioFile);
    formData.append('estimate_id', String(estimateId));
    
    // We need to use a different content type for file uploads
    const response = await api.post('/audio/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    

    return response.data;
  } catch (error) {
    console.error('Error uploading audio:', error);
    throw error;
  }
};

const audioService = {
  getAudioRecordings,
  transcribeAudio,
  processAudioWithAI,
  deleteAudio,
  uploadAudio
};
export default audioService;